import { IHeaderParams } from 'ag-grid-community'
import React from 'react'
import { TypedCellRendererParams } from '.'
import { AgPublicEventType } from 'ag-grid-community/dist/types/core/eventTypes'

export const withRenderOnEvents = <D, T extends IHeaderParams | TypedCellRendererParams<D>>(
  Component: React.ComponentType<T>,
  events: AgPublicEventType[]
) =>
  class extends React.Component<T> {
    updaterFn = () => this.forceUpdate()

    componentDidMount = (): void => events.forEach(eventName => this.props.api.addEventListener(eventName, this.updaterFn))
    componentWillUnmount = (): void =>
      events.forEach(eventName => {
        if (!this.props.api.isDestroyed()) {
          this.props.api.removeEventListener(eventName, this.updaterFn)
        }
      })

    render() {
      return <Component {...this.props} />
    }
  }
